module.exports = __webpack_public_path__ + "static/media/topBanner.b07dffac.webp";